import React, { useState } from "react";

const NewsletterSubscriptionForm = ({ button }) => {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Use the local Firebase Cloud Function URL for testing
        // const url = "http://localhost:5001/inglesautodidata-5b0b9/us-central1/addUserToMailchimp";

        // Use this URL for production
        const url = "https://us-central1-inglesautodidata-5b0b9.cloudfunctions.net/addUserToMailchimp";

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email,
                name: name
            }),
        })
            .then(response => {
                if (!response.ok) {
                    console.log('Response status: ', response.status);  // Log the status code
                    throw new Error('Houve algum erro! 🤔');
                }
                setMessage("");
                setName("");
                setEmail("");
                return response.json();
            })
            .then(responseData => {
                setMessage("Inscrição concluída com sucesso! Por favor, verifique a sua caixa de spam.");
                setName("");
                setEmail("");
                setError("");
            })
            .catch((err) => {
                console.error('There has been a problem with your fetch operation:', err);
                setError(err.message);
                setMessage("");
                setName("");
                setEmail("");
            });
    };

    return (
        <div className="newsletter-form-container">
            <form onSubmit={handleSubmit} className="flex md:flex-row flex-col items-stretch md:items-center justify-start gap-3 w-full">
                <input
                    className="block px-6 py-3 md:py-2.5 flex-1 min-w-[200px] border border-white/30 bg-white/10 backdrop-blur-sm text-white placeholder:text-white/70 rounded-full shadow-sm focus:ring-2 focus:ring-white/50 focus:border-white/50 transition-all duration-300"
                    type="text"
                    placeholder="Seu nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <input
                    className="block px-6 py-3 md:py-2.5 flex-1 min-w-[200px] border border-white/30 bg-white/10 backdrop-blur-sm text-white placeholder:text-white/70 rounded-full shadow-sm focus:ring-2 focus:ring-white/50 focus:border-white/50 transition-all duration-300"
                    type="email"
                    placeholder="Seu email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button
                    className='bg-gradient-to-r from-orange-500 via-orange-500 to-orange-500 px-6 py-3 md:py-2.5 w-full md:w-auto rounded-full text-white font-semibold hover:from-orange-400 hover:via-red-400 hover:to-pink-400 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap'
                    type="submit"
                >
                    {button}
                </button>
            </form>

            {error && (
                <p className="mt-4 px-4 py-3 text-center border border-red-300 rounded-lg bg-red-50 text-red-600 font-semibold shadow-sm animate-fade-in">
                    Houve algum erro! 🤔
                </p>
            )}
            {message && (
                <p className="mt-4 px-4 py-3 text-center border border-green-300 rounded-lg bg-green-50 text-py-green font-semibold shadow-sm animate-fade-in">
                    {message}
                </p>
            )}
        </div>
    );
};

export default NewsletterSubscriptionForm;
